import { HandWithMoneyGreen } from '@eventbrite/eds-iconography';
import { Illustration } from '@eventbrite/eds-illustration';
import { Modal } from '@eventbrite/eds-modal';
import React, { useEffect, useState } from 'react';
import { TAXPAYER_SUMMARY_STATUS } from '../constants';
import { getSessionStorageOrDefault } from '../utils';
import './DocumentRequestModal.scss';
import { getTaxpayerInformation } from './hooks';

const STATE_KEY = 'document_request_status_modal_seen';

export const DocumentRequestModal = () => {
    const orgId =
        typeof window !== 'undefined'
            ? window.__SERVER_DATA__.activeOrganizationId
            : '';
    const keyModalSeen = `${orgId}_${STATE_KEY}`;
    const documentRequestStatus = getTaxpayerInformation(orgId);

    const [isShown, setIsShown] = useState(false);
    const [title, setTitle] = useState('');
    const [subTitle, setSubTitle] = useState('');
    const [buttonText, setButtonText] = useState('');
    const [isMismatchedStatusBody, setIsMismatchedStatusBody] = useState(false);
    const [buttonLink, setButtonLink] = useState('');
    const [modalSeen, setModalSeen] = useState(
        getSessionStorageOrDefault(keyModalSeen, false),
    );

    const subTitleHTML = !isMismatchedStatusBody ? (
        <p className="eds-l-mar-bot-3">{subTitle}</p>
    ) : (
        <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: subTitle,
            }}
        ></div>
    );

    useEffect(() => {
        const statusData = TAXPAYER_SUMMARY_STATUS[documentRequestStatus] || {};
        if (!modalSeen && statusData && statusData.modalNotification) {
            setTitle(statusData.message.title);
            if (
                typeof statusData.message.subTitle === 'string' ||
                statusData.message.subTitle instanceof String
            ) {
                setSubTitle(statusData.message.subTitle);
            } else {
                setSubTitle(statusData.message.subTitle.__html);
                setIsMismatchedStatusBody(true);
            }
            setButtonText(statusData.message.buttonText);
            setButtonLink(statusData.message.buttonLink);
            setIsShown(true);
        } else {
            setIsShown(false);
        }
    }, [orgId, documentRequestStatus, title, subTitle, buttonLink, modalSeen]);

    useEffect(() => {
        sessionStorage.setItem(keyModalSeen, JSON.stringify(modalSeen));
    }, [modalSeen, keyModalSeen]);

    const closeModal = () => {
        setIsShown(false);
        setModalSeen(true);
    };

    const redirectOnClick = () => {
        closeModal();
        window.location.href = buttonLink;
    };

    const illustrationContent = (
        <section>
            <h2 className="eds-text-hs--fixed eds-l-mar-bot-3">{title}</h2>
            {subTitleHTML}
        </section>
    );

    return (
        <Modal
            isShown={isShown}
            noMinHeight={true}
            isClosable={true}
            disableCloseOnClickOutside={true}
            onClose={closeModal}
            primaryText={buttonText}
            primaryType="fill"
            onPrimaryAction={() => {
                redirectOnClick();
            }}
            illustration={
                <Illustration
                    type={<HandWithMoneyGreen />}
                    height="350px"
                    width="auto"
                />
            }
        >
            {illustrationContent}
        </Modal>
    );
};

export default DocumentRequestModal;
